import '../css/CheckResume.css';
import '../css/ViewResume.css';
import {systemConfiguration ,Endpoint}from '../../../src/CommonImports';
import {useState,useNavigate,axios}from '../../../src/InBuildImports';


const ViewResume = () => {
  const [isTextareaVisible, setTextareaVisible] = useState(false);
  const [isVisible, setisVisible] = useState(true);
  const [inputText, setinputText] = useState('');
  const navigate = useNavigate();

  const handleClick =async () => {
    setTextareaVisible(true);
    setisVisible(false)
    const response = await axios.put(`${systemConfiguration.HOST}${Endpoint.UPDATE_SECURITY_TABLE}`);
    
  };

  const handleSubmit=(e)=>{
    e.preventDefault();
    
    if(inputText !== ''){
      navigate('/CheckResume?securityKey='+inputText);
     }else{
        alert('please enter valid input');
        return false;
    } 
    return false;
  }
   
  return (

    <div className="Gvcommon-list">
      {(() => {
        if(isVisible==true){
          return <button className='Gvsubmitview' onClick={handleClick}>View Resume</button>
        }
         })()}

        {(() => {   
        if(isTextareaVisible==true){
           return(
            <form onSubmit={handleSubmit}>
            <input className='Gvtext' 
            type="text" 
            value={inputText} 
            onChange={(e) => setinputText(e.target.value)}
            Placeholder='Enter Security Code'>
              </input> 
            <button className='Gvsubmit'  type="submit">Submit</button>
          </form>
           );    
        } 
      
      })()}
       
      </div>

  );
};

export default ViewResume;
